import { NetworkRequest } from '../Utilities/NetworkRequests/NetworkRequests';

export const getAffiliates = async (params) =>
  NetworkRequest('affiliates', params);

export const getAffiliateSpend = async (params) =>
  NetworkRequest('affiliateSpend', params);

export const getPeakHoursConfig = async (params) =>
  NetworkRequest('affiliates', params);

export const getThrottle = async (params) => NetworkRequest('throttle', params);

export const variants = async (params) => NetworkRequest('variants', params);

export const getAffiliateBuyers = async (params) =>
  NetworkRequest('affiliateBuyers', params);

export const getDomainMappings = async (params) =>
  NetworkRequest('emailDomainMapping', params);

export const getAffiliateSignups = async (params) =>
  NetworkRequest('affiliate_signup_internal', params);
